// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.start-scan-button-div, .loader-action-div, .view-summary-button-div {
    text-align: center;
    padding-left: 32px;
    padding-right: 32px;
    padding-bottom: 32px;
    padding-top: 8px;
}

.loader-action-div {
    padding-top: 32px;
}

.start-scan-button, .loader-action-button-active {
    animation: shadow-pulse 1s infinite;
}

.tray-panel {

}

.selected-scan-info-panel {

}

.loader-action-panel {
    margin-right: 8px !important;
}

.loader-action-panel .ant-btn-group {
    margin: auto;
    display: table;
    margin-top: 8px;
    margin-bottom: 8px;
}

.tray-div {
    margin: 8px !important;
    border: 1px solid rgba(206, 206, 206, 0.712);
    border-radius: 8px;
    min-height: 80px !important;
    vertical-align: middle;
}

.tray-panel-inside-div {
    padding-top: 8px;
    padding-bottom: 8px;
}

.tray-div-no-cassette {
    color: white;
    background-color: #0a000054;
    text-align: center;
    font-size: 12px;
}

.tray-div-loaded-for-scanning {
    color: black;
    border: 2px solid orange;
    text-align: center;
    font-size: 12px;
    animation: shadow-pulse3 1.5s infinite;
}

.tray-div-scan-done {
    color: black;
    border: 2px solid rgb(0, 167, 50);
    text-align: center;
    font-size: 12px;
}

.loader-active-slot-div {
    animation: shadow-pulse2 1s infinite;   
    border: 2px solid #007cc794;
    border-radius: 8px;
}

.tray-div-no-preview {
    text-align: center;
    font-size: 12px;
}

.rack-header {
    text-align: center;
    width: 100%;
}

.region-selector-div {
    height: 320px;
    border-color: rgba(206, 206, 206, 0.712);
    border-style: solid;
    border-width: 1px;
    border-radius: 8px;
    margin: 8px;
}

.loader-help-message {
    text-align: center;
    margin-top: 80px;
}

.loader-region-selector-parent {
    border: 1px solid rgba(206, 206, 206, 0.712);
    border-radius: 8px;
    margin: 2vw !important;
}

.loader-tray-action-div {
    position: absolute;
    right: -6px;
    top: -6px;
    background: white;
    padding: 8px;
    padding-left: 10px;
}

.loader-tray-action-right-div {
    position: absolute;
    left: -6px;
    top: -6px;
    background: white;
    padding: 8px;
    padding-right: 10px;
}

.slot-not-scheduled {
    font-size: 10px !important;
    cursor: default !important;
}

.loader-tray-action {
    cursor: pointer;
}

.loader-tray-action:hover {
    color: #0099ff;
}

.tray-take-preview-button {
    font-size: 12px !important;
}

.loader-active-parent {
    height: 800px !important;
    margin-right: 8px !important;
}

.loader-active-slot-child {
    width: 100%;
    height: 736px !important;
}

.tray-slide-preview-img {
    width: 100%;
}

.tray-slide-preview-row, .tray-slide-preview-tag {
    cursor: pointer;
}

.tray-slide-preview-row {
    margin-top: 0 !important;
    margin-left: 8px !important;
    margin-right: 8px !important;
    min-height: 50px !important;
    box-shadow: -2px 0 0 #000, 2px 0 0 #000;
}

.tray-slide-preview-row-finished {
    margin-top: 0 !important;
    margin-left: 8px !important;
    margin-right: 8px !important;
    min-height: 32px !important;
    box-shadow: -2px 0 0 #000, 2px 0 0 #000;
}

.region-selector-canvas {
    width: 400px;   
    margin: 16px;
}

.active-slot-header {
    margin: 8px;
    text-align: center;
    font-size: 14px;
}

.tray-slide-preview-tag {
    padding-left: 8px;
    padding-right: 8px;
    border-color: rgba(206, 206, 206, 0.712);
    border-style: solid;
    border-width: 1px;
    border-top: 0;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    margin-left: 8px !important;
    margin-right: 8px !important;
    margin-bottom: 4px !important;
    text-align: center;
    font-size: 10px;
}

.errored {
    background-color: salmon;
}

.tray-header {
    text-align: center;
    font-size: 12px;
}

.tray-divider {
    padding-left: 16px;
    padding-right: 16px;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/scanner/loader.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,4CAA4C;IAC5C,kBAAkB;IAClB,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,YAAY;IACZ,iCAAiC;IACjC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,wCAAwC;IACxC,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,4CAA4C;IAC5C,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;IAC3B,uCAAuC;AAC3C;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;IAC3B,uCAAuC;AAC3C;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,+BAA+B;IAC/B,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB","sourcesContent":[".start-scan-button-div, .loader-action-div, .view-summary-button-div {\n    text-align: center;\n    padding-left: 32px;\n    padding-right: 32px;\n    padding-bottom: 32px;\n    padding-top: 8px;\n}\n\n.loader-action-div {\n    padding-top: 32px;\n}\n\n.start-scan-button, .loader-action-button-active {\n    animation: shadow-pulse 1s infinite;\n}\n\n.tray-panel {\n\n}\n\n.selected-scan-info-panel {\n\n}\n\n.loader-action-panel {\n    margin-right: 8px !important;\n}\n\n.loader-action-panel .ant-btn-group {\n    margin: auto;\n    display: table;\n    margin-top: 8px;\n    margin-bottom: 8px;\n}\n\n.tray-div {\n    margin: 8px !important;\n    border: 1px solid rgba(206, 206, 206, 0.712);\n    border-radius: 8px;\n    min-height: 80px !important;\n    vertical-align: middle;\n}\n\n.tray-panel-inside-div {\n    padding-top: 8px;\n    padding-bottom: 8px;\n}\n\n.tray-div-no-cassette {\n    color: white;\n    background-color: #0a000054;\n    text-align: center;\n    font-size: 12px;\n}\n\n.tray-div-loaded-for-scanning {\n    color: black;\n    border: 2px solid orange;\n    text-align: center;\n    font-size: 12px;\n    animation: shadow-pulse3 1.5s infinite;\n}\n\n.tray-div-scan-done {\n    color: black;\n    border: 2px solid rgb(0, 167, 50);\n    text-align: center;\n    font-size: 12px;\n}\n\n.loader-active-slot-div {\n    animation: shadow-pulse2 1s infinite;   \n    border: 2px solid #007cc794;\n    border-radius: 8px;\n}\n\n.tray-div-no-preview {\n    text-align: center;\n    font-size: 12px;\n}\n\n.rack-header {\n    text-align: center;\n    width: 100%;\n}\n\n.region-selector-div {\n    height: 320px;\n    border-color: rgba(206, 206, 206, 0.712);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 8px;\n    margin: 8px;\n}\n\n.loader-help-message {\n    text-align: center;\n    margin-top: 80px;\n}\n\n.loader-region-selector-parent {\n    border: 1px solid rgba(206, 206, 206, 0.712);\n    border-radius: 8px;\n    margin: 2vw !important;\n}\n\n.loader-tray-action-div {\n    position: absolute;\n    right: -6px;\n    top: -6px;\n    background: white;\n    padding: 8px;\n    padding-left: 10px;\n}\n\n.loader-tray-action-right-div {\n    position: absolute;\n    left: -6px;\n    top: -6px;\n    background: white;\n    padding: 8px;\n    padding-right: 10px;\n}\n\n.slot-not-scheduled {\n    font-size: 10px !important;\n    cursor: default !important;\n}\n\n.loader-tray-action {\n    cursor: pointer;\n}\n\n.loader-tray-action:hover {\n    color: #0099ff;\n}\n\n.tray-take-preview-button {\n    font-size: 12px !important;\n}\n\n.loader-active-parent {\n    height: 800px !important;\n    margin-right: 8px !important;\n}\n\n.loader-active-slot-child {\n    width: 100%;\n    height: 736px !important;\n}\n\n.tray-slide-preview-img {\n    width: 100%;\n}\n\n.tray-slide-preview-row, .tray-slide-preview-tag {\n    cursor: pointer;\n}\n\n.tray-slide-preview-row {\n    margin-top: 0 !important;\n    margin-left: 8px !important;\n    margin-right: 8px !important;\n    min-height: 50px !important;\n    box-shadow: -2px 0 0 #000, 2px 0 0 #000;\n}\n\n.tray-slide-preview-row-finished {\n    margin-top: 0 !important;\n    margin-left: 8px !important;\n    margin-right: 8px !important;\n    min-height: 32px !important;\n    box-shadow: -2px 0 0 #000, 2px 0 0 #000;\n}\n\n.region-selector-canvas {\n    width: 400px;   \n    margin: 16px;\n}\n\n.active-slot-header {\n    margin: 8px;\n    text-align: center;\n    font-size: 14px;\n}\n\n.tray-slide-preview-tag {\n    padding-left: 8px;\n    padding-right: 8px;\n    border-color: rgba(206, 206, 206, 0.712);\n    border-style: solid;\n    border-width: 1px;\n    border-top: 0;\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px;\n    margin-left: 8px !important;\n    margin-right: 8px !important;\n    margin-bottom: 4px !important;\n    text-align: center;\n    font-size: 10px;\n}\n\n.errored {\n    background-color: salmon;\n}\n\n.tray-header {\n    text-align: center;\n    font-size: 12px;\n}\n\n.tray-divider {\n    padding-left: 16px;\n    padding-right: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
